import { render, staticRenderFns } from "./feedbacklist.vue?vue&type=template&id=66a198ec&scoped=true"
import script from "./feedbacklist.vue?vue&type=script&lang=js"
export * from "./feedbacklist.vue?vue&type=script&lang=js"
import style0 from "./feedbacklist.vue?vue&type=style&index=0&id=66a198ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a198ec",
  null
  
)

export default component.exports